import React from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import { getFieldProperties, getFieldPropertyValues } from './helpers';
import { PRIVACY_LINK } from '../constants';

const flex = {
  display: 'flex',
  justifyContent: 'center'
};
const flexItem = {
  marginLeft: '10px'
};
const buttonStyle = {
  width: '160px',
  backgroundColor: '#2f68fd',
  borderColor: '#2f68fd',
  borderRadius: '15px',
  color: 'white',
  margin: '0px auto',
  fontSize: '15px',
  fontFamily: 'TTCommons',
  cursor: 'pointer',
  padding: '8px 10px',
  outline: 'none',
  display: 'block',
  boxShadow:
    '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
  border: '0px solid'
};

const resetButtonStyle = {
  ...buttonStyle,
  width: '100px',
  backgroundColor: '#C57969'
};

const privacyLinkStyle = {
  marginTop: '2rem',
  textAlign: 'center',
};

const launchIconStye = {
  fontSize: 'inherit',
  marginLeft: '0.25rem',
  verticalAlign: 'middle',
};

export const FormFieldSubmit = ({
  field,
  onFieldClick,
  onFieldResetClick,
  pageNum,
  displayPrevious,
  displayReset,
  onPageChange,
  disabled
}) => {
  const handleFieldClick = e => {
    e.stopPropagation();
    onFieldClick(field);
  };

  const properties = getFieldProperties(field, 'common');
  const propertyValues = getFieldPropertyValues(properties.common, 'label');

  return (
    <div key={field.uuid} className='form-field-submit'>
      {displayPrevious && (
        <input
          type='button'
          className='btn btn-secondary pull-left'
          value='Previous'
          onClick={() => onPageChange(pageNum - 1)}
        />
      )}

      {/*<input*/}
      {/*  type='button'*/}
      {/*  className='btn btn-primary'*/}
      {/*  value={propertyValues.label}*/}
      {/*  onClick={handleFieldClick}*/}
      {/*  disabled={disabled}*/}
      {/*/>*/}
      <div style={flex}>
        {displayReset && (
          <div style={flexItem}>
            <button
              style={resetButtonStyle}
              type='button'
              onClick={() => onFieldResetClick()}
            >
              <span>Reset</span>
            </button>
          </div>
        )}
        <div style={flexItem}>
          <button
            style={buttonStyle}
            disabled={disabled}
            type='button'
            onClick={handleFieldClick}
          >
            <span>{propertyValues.label}</span>
          </button>
        </div>
      </div>
      <div className='form-field-link' style={privacyLinkStyle}>
        <a href={PRIVACY_LINK.url} target='_blank' rel='noopener'>
          {PRIVACY_LINK.text}
        </a>
        <LaunchIcon style={launchIconStye} />
      </div>
    </div>
  );
};

export default FormFieldSubmit;

FormFieldSubmit.defaultProps = {
  pageNum: 1,
  displayPrevious: false,
  onPageChange: () => {
  },
  disabled: false
};
